import type WorkflowDefinitionModel from '@src/service/model/workflow/WorkflowDefinitionModel'

import Repository from './base'

export const WORKFLOW_DEFINITION_TABLE_NAME = 'workflowDefinition'
export class WorkflowDefinitionRepository extends Repository<WorkflowDefinitionModel> {}
